import React, { useState } from "react";
import PositionTable from "./components/PositionTable";
import PositionAddEditModal from "./components/PositionAddEditModal";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';
import { FEATURES } from "../../../../config/features";

const PositionModule = ({ user, data, loading, searchData, createPosition, updatePosition }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  const handleSave = async (form) => {
    if (selectedItem) {
      let auditInfo = [];
      const fields = [
        { key: 'code', label: 'Code', enabled: FEATURES.POSITION_CODE },
        { key: 'description', label: 'Description', enabled: true },
      ];

      fields.forEach(f => {
        if (f.enabled && form[f.key] !== selectedItem[f.key]) {
          auditInfo.push({
            setupArea: "Position",
            actionTaken: "update",
            field: f.label,
            newValue: form[f.key],
            oldValue: selectedItem[f.key] || "-",
            dateSaved: new Date(),
            savedById: user.id,
          });
        }
      });

      if (form.isActive !== selectedItem.isActive) {
        auditInfo.push({
          setupArea: "Position",
          actionTaken: "update",
          field: "Is Active?",
          newValue: form.isActive ? "Active" : "Inactive",
          oldValue: selectedItem.isActive ? "Active" : "Inactive",
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      const res = await updatePosition(selectedItem.id, form, auditInfo);
      if (res.success) setIsModalOpen(false);
    } else {
      // Create Audit
      let newValueString = "";
      if (FEATURES.POSITION_CODE) newValueString += `${form.code} - `;
      newValueString += form.description;

      const audit = {
        setupArea: "Position",
        actionTaken: "insert",
        field: "Add",
        newValue: newValueString,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      };
      const res = await createPosition(form, audit);
      if (res.success) setIsModalOpen(false);
    }
  };

  return (
    <>
      <div className='p-4 space-y-4'>
        <div className="flex justify-between items-center">
          <SearchBar handleFilter={(val) => { setCurrentPage(1); searchData(val); }} />
          <Button
            icon={<AddIcon />}
            name={"Add Position"}
            className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
            onClick={() => { setSelectedItem(null); setIsModalOpen(true); }}
          />
        </div>

        <PositionTable
          data={data}
          onEdit={handleEdit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </div>

      <PositionAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
      />
    </>
  );
};

export default PositionModule;